export interface BudgetLine {
  id: string
  name: string
  type: 'Interno' | 'Esterno'
  budget: number
  spent: number
  apiKeyMasked: string
  fornitore?: string
}

export interface Provider {
  id: string
  name: string
  logo?: string
  status: 'Active' | 'Inactive'
  models: string[]
  color: string
  budgetLines: BudgetLine[]
}

export const MOCK_PROVIDERS: Provider[] = [
  {
    id: 'p1',
    name: 'OpenAI',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/OpenAI_Logo.svg/120px-OpenAI_Logo.svg.png',
    status: 'Active',
    models: ['GPT-4o', 'GPT-4o-mini', 'GPT-4-turbo'],
    color: '#10a37f',
    budgetLines: [
      {
        id: 'bl1',
        name: 'Account Principale SIAE',
        type: 'Interno',
        budget: 5000,
        spent: 2435,
        apiKeyMasked: 'sk-...Xk4f',
      },
      {
        id: 'bl2',
        name: 'Account Progetto Speciale',
        type: 'Interno',
        budget: 2000,
        spent: 890,
        apiKeyMasked: 'sk-...9mPq',
      },
      {
        id: 'bl3',
        name: 'Account Fornitore TechCorp',
        type: 'Esterno',
        budget: 3000,
        spent: 1200,
        apiKeyMasked: 'sk-...Lw2n',
        fornitore: 'TechCorp S.r.l.',
      },
    ],
  },
  {
    id: 'p2',
    name: 'Anthropic',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Anthropic_logo.svg/120px-Anthropic_logo.svg.png',
    status: 'Active',
    models: ['Claude 3.5 Sonnet', 'Claude 3 Haiku'],
    color: '#d4a574',
    budgetLines: [
      {
        id: 'bl4',
        name: 'Account Principale',
        type: 'Interno',
        budget: 3000,
        spent: 1560,
        apiKeyMasked: 'sk-ant-...8kPl',
      },
    ],
  },
  {
    id: 'p3',
    name: 'Google AI',
    logo: 'https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA',
    status: 'Active',
    models: ['Gemini 1.5 Pro', 'Gemini 1.5 Flash'],
    color: '#4285f4',
    budgetLines: [
      {
        id: 'bl5',
        name: 'Account GCP SIAE',
        type: 'Interno',
        budget: 2000,
        spent: 680,
        apiKeyMasked: 'AIza...xQ9r',
      },
      {
        id: 'bl6',
        name: 'Account Fornitore DataVision',
        type: 'Esterno',
        budget: 1500,
        spent: 420,
        apiKeyMasked: 'AIza...mK3p',
        fornitore: 'DataVision S.p.A.',
      },
    ],
  },
  {
    id: 'p4',
    name: 'Azure OpenAI',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Microsoft_Azure.svg/120px-Microsoft_Azure.svg.png',
    status: 'Active',
    models: ['GPT-4o (Azure)', 'GPT-4-turbo (Azure)'],
    color: '#0078d4',
    budgetLines: [
      {
        id: 'bl7',
        name: 'Sottoscrizione Enterprise',
        type: 'Interno',
        budget: 4000,
        spent: 1890,
        apiKeyMasked: 'az-...Hj7k',
      },
    ],
  },
  {
    id: 'p5',
    name: 'Mistral AI',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Mistral_AI_logo.svg/120px-Mistral_AI_logo.svg.png',
    status: 'Inactive',
    models: ['Mistral Large', 'Mistral Medium'],
    color: '#ff7000',
    budgetLines: [
      {
        id: 'bl8',
        name: 'Account Test',
        type: 'Interno',
        budget: 500,
        spent: 45,
        apiKeyMasked: 'mst-...Qw4r',
      },
    ],
  },
  {
    id: 'p6',
    name: 'Cohere',
    status: 'Inactive',
    models: ['Command R+', 'Command R'],
    color: '#39594d',
    budgetLines: [
      {
        id: 'bl9',
        name: 'Account Fornitore AILab',
        type: 'Esterno',
        budget: 1000,
        spent: 120,
        apiKeyMasked: 'co-...Pp8s',
        fornitore: 'AILab S.r.l.',
      },
    ],
  },
]

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value)
}

export function getInitials(name: string) {
  return name.substring(0, 2).toUpperCase()
}

export function getProviderTotals(provider: Provider) {
  const totalBudget = provider.budgetLines.reduce((sum, l) => sum + l.budget, 0)
  const totalSpent = provider.budgetLines.reduce((sum, l) => sum + l.spent, 0)
  return {
    totalBudget,
    totalSpent,
    percent: totalBudget > 0 ? Math.round((totalSpent / totalBudget) * 100) : 0,
  }
}
